// @flow
import * as React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import memoize from 'memoizee';

import minimalRelatedUserFragment from 'user/fragments/minimalRelatedUserFragment.gql';

const DATA_RELOAD_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes, for memoize

type Props = {
  children: Function,
  query: string,
  relation: 'parent' | 'child',
  data: ReactApolloData<SearchForFamilyMembersQuery>,
  isMinQueryLength: boolean,
};

class FamilyTypeaheadContainer extends React.Component<Props, void> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.query !== this.props.query && this.props.isMinQueryLength) {
      this.loadQuery(this.props.query);
    }
  }

  loadQuery = memoize(
    query => {
      this.props.data.refetch({ query });
    },
    { maxAge: DATA_RELOAD_TIMEOUT_MS }
  );

  isLoading = (props: Props): boolean => {
    return props.data.loading || props.data.networkStatus < 7;
  };

  getFamilyMembers = (props: Props): *[] => {
    return props.data.potentialFamily || [];
  };

  render() {
    return this.props.children({
      loading: this.isLoading(this.props),
      familyMembers: this.getFamilyMembers(this.props),
    });
  }
}

const withFamilyResults = graphql(
  gql`
    query SearchForFamilyMembers($relation: String!, $query: String!) {
      potentialFamily(relation: $relation, query: $query) {
        query_key
        user {
          ...minimalRelatedUser
        }
      }
    }
    ${minimalRelatedUserFragment}
  `,
  {
    options: ({ relation, query }) => ({
      variables: {
        relation,
        query,
      },
    }),
  }
);

export { FamilyTypeaheadContainer };

export default withFamilyResults(FamilyTypeaheadContainer);
